var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaiIcSendmono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7781 5.34684L5.00098 10.4226L9.18984 11.3558C9.72891 11.4759 10.0686 12.0103 9.94846 12.5493C9.82836 13.0884 9.294 13.428 8.75493 13.308L4.56608 12.3747C2.61863 11.9409 2.43737 9.23568 4.30957 8.54592L19.1032 3.09563C20.304 2.65325 21.4717 3.82094 21.0293 5.02171L15.5013 20.0263C14.8251 21.8615 12.1882 21.7353 11.6904 19.8438L10.1445 13.9694C9.96351 13.2815 10.1615 12.5492 10.6645 12.0462L13.7583 8.95236C14.1489 8.56183 14.782 8.56183 15.1725 8.95236C15.5631 9.34288 15.5631 9.97605 15.1725 10.3666L12.0787 13.4604L13.6246 19.3349L18.7781 5.34684Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiIcSendmono);
export default __webpack_public_path__ + "static/media/mai-ic-send.mono.a136c3de1afc234ae74c778e95b7581c.svg";
export { ForwardRef as ReactComponent };